
import React, { useState, useEffect } from 'react';

const Weather = () => {
  const [city, setCity] = useState('Paris');
  const [weatherData, setWeatherData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const apiKey = '41386ebcf05aed7668ba7df59987760f';  // Remplace par ta clé API OpenWeatherMap

  useEffect(() => {
    const fetchWeatherData = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await fetch(
          `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`
        );
        if (!response.ok) throw new Error('Données non disponibles');
        const data = await response.json();
        setWeatherData(data);
      } catch (error) {
        setError('Erreur de récupération des données météo');
      }
      setLoading(false);
    };

    fetchWeatherData();
  }, [city]);

  const handleCityChange = (event) => setCity(event.target.value);

  return (
    <div className="weather-container">
      <h1>Application Météo</h1>
      <input
        type="text"
        placeholder="Entrez une ville"
        value={city}
        onChange={handleCityChange}
      />
      {loading && <p>Chargement...</p>}
      {error && <p>{error}</p>}
      {weatherData && (
        <div>
          <h2>{weatherData.name}</h2>
          <p>Température: {weatherData.main.temp}°C</p>
          <p>{weatherData.weather[0].description}</p>
        </div>
      )}
    </div>
  );
};

export default Weather;
